import { WireTypes } from "@flakiness/server/common/wireTypes.js";
import { markdown } from "../markdown.js";
import { ciTabs } from "./welcome_ci_tabs.js";
import { accessToken } from "./welcome_new_project.js";

const ghaOIDCInstructions = () => markdown`
  Enable the \`id-token: write\` permission in your workflow:

  ${markdown.yaml(`
    permissions:
      contents: read # Required for actions/checkout
      id-token: write # Required for GitHub OIDC

    steps:
      - uses: actions/checkout@v4
      - name: Run Vitest tests
        run: npx vitest run
  `, `.github/workflows/vitest.yml`, { ins: [[1, 3]] })}
`;

const gitlabOIDCInstructions = (project: WireTypes.Project) => markdown`
  GitLab mints the ID token when the job starts, so declare one named \`FLAKINESS_ID_TOKEN\` with your project as its audience:

  ${markdown.yaml(`
    test:
      id_tokens:
        FLAKINESS_ID_TOKEN:
          aud: ${project.org.orgSlug}/${project.projectSlug} # Required for GitLab OIDC
      script:
        - npx vitest run
  `, `.gitlab-ci.yml`, { ins: [[2, 4]] })}
`;

const otherCIInstructions = (project: WireTypes.Project) => markdown`
  Set the \`FLAKINESS_ACCESS_TOKEN\` environment variable to ${accessToken(project)} and run your tests:

  ${markdown.bash(`
    FLAKINESS_ACCESS_TOKEN=<token> npx vitest run
  `)}
`;

export const welcome_vitest = (project: WireTypes.Project) => markdown`

1. Install the Flakiness.io Vitest reporter:

    ${markdown.bash(`
      npm i -D @flakiness/vitest
    `)}

1. Add Flakiness.io Vitest Reporter to the \`vitest.config.ts\` file:

    ${markdown.ts(`
      import { defineConfig } from 'vitest/config';
      import flakinessReporter from '@flakiness/vitest';

      export default defineConfig({
        test: {
          reporters: [
            'default',
            flakinessReporter({ flakinessProject: '${project.org.orgSlug}/${project.projectSlug}' }),
          ],
        },
      });
    `, `vitest.config.ts`, { ins: [[2, 2], [6, 9]] })}

1. Configure your CI
    ${ciTabs({
      idPrefix: 'vt',
      project,
      githubActions: ghaOIDCInstructions(),
      gitlabCI: gitlabOIDCInstructions(project),
      otherCI: otherCIInstructions(project),
    })}
`;
